import { ContractStatusEnum } from '@mindly/ui-components';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { fetchLastContractBySpecialistId } from 'src/api/contracts';
import { consultationsSelector } from 'src/redux/consultations/selector';
import { psychologistSelectorById } from 'src/redux/specialists/selector';
import { lastActiveSubscriptionSelector } from 'src/redux/subscriptions/selector';

export const useIsTrialSession = (id: string) => {
  const consultations = useSelector(consultationsSelector);
  const specialist = useSelector(psychologistSelectorById(id));
  const subscription = useSelector(lastActiveSubscriptionSelector(id));

  const checkIsTrialSession = useCallback(async () => {
    const contractData = await fetchLastContractBySpecialistId(id ?? '');
    return (
      specialist?.mindly_contract_status === ContractStatusEnum.active &&
      !contractData?.id &&
      !subscription &&
      !consultations?.some((c) => c.psychologist_id === id)
    );
  }, [specialist?.mindly_contract_status, subscription, consultations, id]);

  return { checkIsTrialSession };
};
